import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "team-info",
  class: "h-100 ml-md-4 mr-md-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeamProjects = _resolveComponent("TeamProjects")!
  const _component_TeamMembers = _resolveComponent("TeamMembers")!
  const _component_ProjectHistory = _resolveComponent("ProjectHistory")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TeamProjects, {
      class: "tab",
      ref: "teamProjects"
    }, null, 512),
    _createVNode(_component_TeamMembers, {
      class: "tab d-none",
      ref: "teamMembers"
    }, null, 512),
    _createVNode(_component_ProjectHistory, {
      class: "tab d-none",
      ref: "projectFullHistory"
    }, null, 512),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "glasspane" }, null, -1))
  ]))
}